import React, { useState } from 'react';
import {
	Box,
	Button,
	ClickAwayListener,
	Grid,
	makeStyles,
	Slide,
	Typography,
	IconButton,
	SvgIcon,
	CircularProgress
} from '@material-ui/core';
import Label from 'src/components/Label';
import moment from 'moment';
import clsx from 'clsx';
import { Clear as ClearIcon } from '@material-ui/icons';
import { AlignCenter, Download as DownloadIcon} from 'react-feather';
import invoiceService from 'src/services/invoiceService';

import { PROFILING } from 'src/utils/profilingKeys';
import userInfo from 'src/services/userInfo';
import { ReactComponent as PagoPAIcon } from 'src/assets/icons/pagoPA.svg';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import EuroSymbol from '@material-ui/icons/EuroSymbol';
import { useSnackbar } from 'notistack';
import appMobileService from 'src/services/appMobile.service';


const useStyles = makeStyles(theme => ({
	itemContainer: {
		padding: theme.spacing(2)
	},
	close: {
		background: theme.palette.error.main,
		color: theme.palette.common.white,
		padding: theme.spacing(2)
	}
}))

function InvoiceItem({ entity, disabled = false, className, idContractLine = null }) {
	const solutionPAMObile = userInfo.can(PROFILING.SOLUTION_PA.READ_MOBILE);
	const classes = useStyles();
	const [active, setActive] = useState(false);
	const [activePagoPA, setActivePagoPA] = useState(false);
	const [loading, setLoading] = useState(false);
	const { enqueueSnackbar } = useSnackbar();

	function downloadPDF(type) {
		invoiceService
			.download(entity?.id, type)
			.catch(e => alert('Nessuna Fattura Trovata!'))
			.finally(() => {
			})
	}

	function handleClick(open) {
		if(!disabled && activePagoPA)
			setActivePagoPA(false);

		setActive(open);
	}

	function handleClickPagoPA(open) {
		if(!disabled && active)
			setActive(false);

		setActivePagoPA(open);
	}

	function attivaRptPagoPA() {
		setLoading(true);
		invoiceService
		.pdpAttivaRpt(entity?.id)
		.then(res => {
			if (res.status === 200) {
				
				if ( (appMobileService.isMobile() && appMobileService.getDeviceType() === 'IOS')) {
					appMobileService.goToPagoPAForIOS(res?.data?.redirectURL);

					enqueueSnackbar('Procedura PagoPA, avviata con successo', {
						variant: 'success'
					});

					setTimeout(function(){
						window.location.reload();
					}, 15000);
				} else {
					window.open(res?.data?.redirectURL, '_blank');

					enqueueSnackbar('Procedura PagoPA, avviata con successo', {
						variant: 'success'
					});

					setTimeout(function(){
						window.location.reload();
					}, 2000);
				}
			}
		})
		.catch(err => {
			enqueueSnackbar('Ops! Qualcosa è andato storto', {
				variant: 'error'
			});
		})
		.finally(() => {
			handleClickPagoPA();
			setLoading(false);
		})
	}

	function downloadPagoPA(){
		setLoading(true);
		invoiceService
			.downloadPdpRecuperaRt(entity?.id)
			.catch(err => {
				alert('Errore download della ricevuta ',err.message);
				enqueueSnackbar('Probabilmente la procedura di pagamento non è stata completata', {
					variant: 'error'
				});

				
			})
			.finally(() => {
				handleClickPagoPA();
				setLoading(false);
			})
	}

	return (
		<Box
			width="100%"
			height="100%"
			display="flex"
			className={clsx(classes, className)}
		>
			{!active && !activePagoPA ? (
				<Grid
					container
					justify="space-between"
					alignItems="center"
					//onClick={handleClick}
					className={classes.itemContainer}
				>
					<Grid item>
						<Typography variant="body1" color="textPrimary">
							{entity?.contract?.podPdr?.code}
						</Typography>
						<Typography variant="subtitle2" color="textPrimary">
							{entity?.no}
						</Typography>
						<Typography variant="body2" color="textSecondary">
							{entity?.contractNo}
						</Typography>

						<Typography variant="body2" color="textSecondary">
							{`${moment(entity?.invoiceBeginPeriod).format(
								'MMM YY'
							)} - ${moment(entity?.invoiceEndPeriod).format('MMM YY')}`}
						</Typography>

						<Box mt={1}>
							<Typography variant="body2" color="textSecondary">
							Scadenza {moment(entity?.invoiceExpireDate).format('DD/MM/YYYY')}
							</Typography>
						</Box>
					</Grid>

					<Grid item align="right">
						<Typography variant="body1" color="textSecondary">
							€ {entity?.totalToPay?.toLocaleString()}
						</Typography>
						{entity?.total>0 ? (<Label color={entity?.payed ? 'success' : (entity?.partialPayed ? 'warning' : 'error')}>
							{entity?.payed ? 'Pagata' : (entity?.partialPayed ? 'PAGATA PARZ.' : 'DA PAGARE' )}
						</Label>) : ""}
						{entity?.total>0 && entity?.partialPayed ? (
						<Typography variant="body2" color="textSecondary">
							Residuo € {entity?.totalResidual?.toLocaleString()}
						</Typography>) : ""}
						{
							solutionPAMObile && entity?.hasIuvPagoPA  ? (
								<Box mt={1}>
									<IconButton
											label="Download Fattura"
											//onClick={handleClick}
											onClick={(event) => {
												handleClick(true);
												handleClickPagoPA(false);
											
										}}
									>
											<SvgIcon fontSize="small" >
												<PictureAsPdfIcon />
											</SvgIcon>
									</IconButton>
									<IconButton
									label="PagoPA"
									//onClick={handleClickPagoPA}
									onClick={(event) => {
											handleClick(false);
											handleClickPagoPA(true);
								}}
									>
											<SvgIcon fontSize="small">
														<PagoPAIcon />
											</SvgIcon>
									</IconButton>
								</Box>
							) : (
								<Box mt={1}>
									<IconButton
											label="Download Fattura"
												onClick={(event) => {
														handleClick(true);
														handleClickPagoPA(false);
													
												}}

									>
											<SvgIcon fontSize="small" >
												<PictureAsPdfIcon />
											</SvgIcon>
									</IconButton>
								</Box>
							)
						}
					</Grid>
				</Grid>
			) : (
				<ClickAwayListener 
				//onClickAway={() => setActive(false)}
				onClickAway={(event) => {
					setActive(false);
					setActivePagoPA(false);
				
				}}
				>
					<Slide direction="left" in={active || activePagoPA} mountOnEnter unmountOnExit>
						<Box
							width="100%"
							height="100%"
							display="flex"
							className={clsx(classes, className)}
						>
							<Box
								height="100%"
								display="flex"
								alignItems="center"
								className={classes.close}
								onClick={(event) => {
									if(active) {
										handleClick(false);
									}
									if(activePagoPA && !loading) {
										handleClickPagoPA(false);
									}
									
								}}
							>
								<ClearIcon />
							</Box>


							{ activePagoPA ? (
								<>
								{loading ? (
									<CircularProgress size={50}         
									left={-50}
									top={30}
									//status={'loading'}
									style={{marginLeft: '25%', marginTop: '7%'}}/>
								) : (
									<Box
									display="flex"
									justifyContent="space-between"
									width="100%"
									p={3}
									>
	
	
									<Button 
									disabled={entity?.payed || entity?.partialPayed}
									onClick={() => attivaRptPagoPA()}>
										<div>
											<div>
												<EuroSymbol fontSize="small" />
											</div>
											Vai al pagamento
										</div>
									</Button>

									<Button
									onClick={() => downloadPagoPA()}>
										<div>
											<div>
												<DownloadIcon fontSize="small" />
											</div>
											Richiedi ricevuta
										</div>
									</Button>
									</Box>
								 )}



								</>

								
							) : (
								<Box
								display="flex"
								justifyContent="space-between"
								width="100%"
								p={3}
							>
								<Button onClick={() => downloadPDF('sintetico')}>
									<div>
										<div>
											<DownloadIcon fontSize="small" />
										</div>
										Sintetica
									</div>
								</Button>

								<Button onClick={() => downloadPDF('dettaglio')}>
									<div>
										<div>
											<DownloadIcon fontSize="small" />
										</div>
										Dettagliata
									</div>
								</Button>
							</Box>
							) 
							}
						</Box>
					</Slide>
				</ClickAwayListener>
			)}
		</Box>
	);
}

export default InvoiceItem;